import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import HomeView from '../views/HomeView.vue'

// importurile componentelor tale
import Calendar from '../views/Calendar/Calendar.vue'
import Documente from '../views/Documente/Documente.vue'
import LiniiDocumente from '../views/Documente/LiniiDocumente.vue'
import RaportCashFlowView from '../views/Rapoarte/RaportCashFlowView.vue'
import Oportunitati from '../views/Comercial/CRM/Oportunitati.vue'
import AdminView from '../views/ADMIN/Admin.vue'
import Nomenclatoare from '../views/ADMIN/Nomenclatoare.vue'
import GridContacte from '../views/Comercial/CRM/GridContacte.vue'
import GridOportunitati from '../views/Comercial/CRM/GridOportunitati.vue'
import GridTabActivitati from '../views/Comercial/CRM/GridTabActivitati.vue'
import CRMDashboard from '../views/Comercial/CRM/CRMDashboard.vue'
import GridRoluri from '../views/AUTH/GridRoluri.vue'
import GridRoluriUtilizatori from '../views/AUTH/GridRoluriUtilizatori.vue'
import GridDrepturiCustom from '../views/AUTH/GridDrepturiCustom.vue'
import GridDrepturiUtilizatori from '../views/AUTH/GridDrepturiUtilizatori.vue'
import GridDrepturiRoluri from '../views/AUTH/GridDrepturiRoluri.vue'
import GridBilanturi from '../views/Contabilitate/GridBilanturi.vue'
import GridFormuleRanduri from '../views/Contabilitate/GridFormuleRanduri.vue'
import GridTabMeniuBilanturi from '../views/Contabilitate/GridTabMeniuBilanturi.vue'
import GridDrepturiCustomsiMeniu from '../views/AUTH/GridDrepturiCustomsiMeniu.vue'
import GridUtilizatorisiDrepturi from '../views/AUTH/GridUtilizatorisiDrepturi.vue'
import GridRolurisiDrepturi from '../views/AUTH/GridRolurisiDrepturi.vue'
import GridUtilizatori from '../views/AUTH/GridUtilizatori.vue'
import PreturiFurnizor from '../views/Comercial/PreturiFurnizor.vue'
import ForgotPassword from '@/views/AUTH/ForgotPassword.vue'
import LoginView from '@/views/AUTH/LoginView.vue'
import ValidationCode from '@/views/AUTH/ValidationCode.vue'
import MainLayout from '@/views/MainLayout.vue'
import Drepturi from './../views/AUTH/Drepturi.vue'
import PRO_Clase from '@/views/PRO/PRO_Clase.vue'
import ClaseSiCategorii from '@/views/PRO/ClaseSiCategorii.vue'
import PRO_Categorii from '@/views/PRO/PRO_Categorii.vue'
import ProComenzi from '@/views/Comercial/Comenzi/PRO_ComenziView.vue'
import PRO_Produse from '@/views/PRO/PRO_Produse.vue'
import Salarizare from '@/views/ResurseUmane/Salarizare/Salarizare.vue'
import TotSalarizare from '@/views/ResurseUmane/Salarizare/ValoriParametriiSalarizare.vue'
import ActualizareDate from '@/views/ResurseUmane/Salarizare/ActualizareDate.vue'
import ValoriParametriSalarizare from '@/services/PER/ValoriParametriSalarizare'
import PER_ActiveEmployees from '@/services/PER/PER_ActiveEmployees'
import Personal from '@/views/ResurseUmane/Personal/Personal.vue'
import GridContracteMunca from '@/views/ResurseUmane/GridContracteMunca.vue'
import CRM_Documente from '@/views/Comercial/CRM/CRM_Documente.vue'
import GridGrilaSalarizare from '@/views/ResurseUmane/GridGrilaSalarizare.vue'
import GridGrupuriAngajati from '@/views/ResurseUmane/GridGrupuriAngajati.vue'
import GridMomenteCalcul from '@/views/ResurseUmane/GridMomenteCalcul.vue'
import GridOrganigrama from '@/views/ResurseUmane/GridOrganigrama.vue'
import GridParteneri from '@/views/Comercial/CRM/GridParteneri.vue'
import GridCampanii from '@/views/Comercial/CRM/GridCampanii.vue'
import TreeAgenti from '@/views/Comercial/TreeAgenti.vue'
import RapoarteUtilizator from '@/views/Rapoarte/RapoarteUtilizator.vue'
import AdminModulCRM from '@/views/Comercial/CRM/AdminModulCRM.vue'
import KPIDashboard from '@/views/Comercial/CRM/KPIDashboard.vue'
import KPIAdmin from '@/views/Comercial/CRM/KPIAdmin.vue'
import CalendarActivitati from '@/views/Comercial/CRM/CalendarActivitati.vue'


const routes: Array<RouteRecordRaw> = [

  { path: '/', name: 'main', component: MainLayout },
  { path: '/validation-code', name: 'ValidationCode', component: ValidationCode },
  { path: '/login', name: 'Login', component: LoginView },
  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },

  { path: '/home', name: 'home', component: HomeView },

  // Calendar
  { path: '/calendar', name: 'Calendar', component: Calendar },

  // Documente
  { path: '/documente', name: 'Documente', component: Documente },
  { path: '/documente/cautare', name: 'CautareDocumente', component: Documente },
  { path: '/linii', name: 'Linii', component: LiniiDocumente },

  //Comercial - Agenti
  { path: '/agenti', name: 'Agenti', component: TreeAgenti },
  // Preturi Furnizor
  { path: '/preturifurnizor', name: 'PreturiFurnizor', component: PreturiFurnizor },

  // Rapoarte
  { path: '/rapoarte/utilizator', name: 'RapoarteUtilizator', component: RapoarteUtilizator },
  { path: '/rapoarte/cashflow', name: 'RaportCashFlowView', component: RaportCashFlowView },

  // CRM
  { path: '/crm/oportunitati', name: 'Oportunitati', component: Oportunitati },
  { path: '/crm/contacte', name: 'GridContacte', component: GridContacte },
  { path: '/crm/grid-oportunitati', name: 'GridOportunitati', component: GridOportunitati },
  { path: '/crm/activitati', name: 'GridTabActivitati', component: GridTabActivitati },
  { path: '/crm/dashboard', name: 'CRMDashboard', component: CRMDashboard },
  { path: '/crm/parteneri', name: 'GridParteneri', component: GridParteneri },
  { path: '/crm/campanii', name: 'GridCampanii', component: GridCampanii },
  { path: '/crm/kpi', name: 'KPIDashboard', component: KPIDashboard },
  { path: '/crm/kpi-admin', name: 'KPIAdmin', component: KPIAdmin },
  { path: '/crm/calendar-activitati', name: 'CalendarActivitati', component: CalendarActivitati },

  // Admin
  { path: '/admin', name: 'AdminView', component: AdminView },
  { path: '/admin/nomenclatoare', name: 'Nomenclatoare', component: Nomenclatoare },
  { path: '/admin/modul-crm', name: 'AdminModulCRM', component: AdminModulCRM },

  // AUTH
  { path: '/auth/roluri', name: 'GridRoluri', component: GridRoluri },
  { path: '/auth/roluri-utilizatori', name: 'GridRoluriUtilizatori', component: GridRoluriUtilizatori },
  { path: '/auth/drepturi-custom', name: 'GridDrepturiCustom', component: GridDrepturiCustom },
  { path: '/auth/drepturi-utilizatori', name: 'GridDrepturiUtilizatori', component: GridDrepturiUtilizatori },
  { path: '/auth/drepturi-roluri', name: 'GridDrepturiRoluri', component: GridDrepturiRoluri },
  { path: '/auth/drepturi-custom-meniu', name: 'GridDrepturiCustomsiMeniu', component: GridDrepturiCustomsiMeniu },
  { path: '/auth/utilizatori-drepturi', name: 'GridUtilizatorisiDrepturi', component: GridUtilizatorisiDrepturi },
  { path: '/auth/roluri-drepturi', name: 'GridRolurisiDrepturi', component: GridRolurisiDrepturi },
  { path: '/auth/utilizatori', name: 'GridUtilizatori', component: GridUtilizatori },
  { path: '/auth/drepturi', name: 'Drepturi', component: Drepturi },

  // Contabilitate
  { path: '/contabilitate/bilanturi', name: 'GridBilanturi', component: GridBilanturi },
  { path: '/contabilitate/formule-randuri', name: 'GridFormuleRanduri', component: GridFormuleRanduri },
  { path: '/contabilitate/tab-meniu-bilanturi', name: 'GridTabMeniuBilanturi', component: GridTabMeniuBilanturi },
  { path: '/clase/:id?', name: 'Clase', component: ClaseSiCategorii },
  { path: '/produse', name: 'Produse', component: PRO_Produse },
  { path: '/personal', name: 'Personal', component: Personal },
  {
    path: '/contracte/:id?',
    name: 'Contracte',
    component: GridContracteMunca,
    props: route => ({
      employeeId: route.params.id,      // aici legăm parametru -> prop
      employeeRow: null                 // sau ceva default, dacă ai nevoie
    })
  },
  {
    path: '/valoriParametriiSalarizare/:empId?',
    name: 'valoriParametriiSalarizare',
    component: ValoriParametriSalarizare
  },
  {
    path: '/actualizareDate/:id?',
    name: 'ActualizareDate',
    component: ActualizareDate
  },
  {
    path: '/activeEmployees/:id?',
    name: 'ActiveEmployees',
    component: PER_ActiveEmployees
  },
  {
    path: '/organigrama',
    name: 'GridOrganigrama',
    component: GridOrganigrama
  },
  {
    path: '/organigrama/tree/:id',
    name: 'TreeOrganigrama',
    component: () => import('@/views/ResurseUmane/TreeOrganigrama.vue'),
    props: true
  },

  // Nomenclatoare 
  {
    path: '/grila-salarizare/detalii/:id',
    name: 'GrilaSalarizareDetalii',
    component: () => import('@/views/ResurseUmane/GrilaSalarizareDetalii.vue'),
    props: true
  },
  {
    path: '/grila-salarizare',
    name: 'GridGrilaSalarizare',
    component: GridGrilaSalarizare
  },
  {
    path: '/momente-calcul',
    name: 'GridMomenteCalcul',
    component: GridMomenteCalcul
  },
  {
    path: '/momente-calcul/detalii/:id',
    name: 'MomenteCalculDetalii',
    component: () => import('@/views/ResurseUmane/MomenteCalculDetalii.vue'),
    props: true
  },

  // Comenzi ProComenzi
  {
    path: '/comenzi/:comandaId?', // Parametrul 'comandaId' este opțional (?)'
    name: 'ProComenzi', component: ProComenzi,
    props: true // Permite trimiterea parametrilor rutei ca props (opțional, dar util)
  },

  {
    path: '/SuperAdmin', name: 'SuperAdmin', component: () => import('@/views/ADMIN/SuperAdmin.vue'), meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
